export const FULL_PERCENT = 100;
export const getPercentage = ({
  value,
  limit
}) => {
  return (value / limit || 0) * FULL_PERCENT;
};
export const getInfinitePercentage = value => {
  return !isFinite(value);
};
export const getOverLimit = ({
  value,
  limit
}) => {
  return value >= limit && limit > 0 || getInfinitePercentage(getPercentage({
    value,
    limit
  }));
};